import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { PASSENGER_FIELD_LEVEL_BADGE } from '../passengerFieldLabels';
import type { PassengerFieldLevel } from '../passengerFields';

interface Props {
  level: PassengerFieldLevel;
}

/** El peso visual de cada nivel: rojo suave bloquea, ámbar espera, neutro suma. */
const TONE_SX = {
  blocking: { bgcolor: 'error.light', color: 'error.contrastText' },
  confirm: { bgcolor: 'warning.light', color: 'warning.contrastText' },
  optional: { bgcolor: 'grey.200', color: 'text.secondary' },
} as const;

/**
 * Qué decisión condiciona ESTE dato, al lado del control que lo carga.
 *
 * Va debajo del campo y no dentro del label de MUI a propósito: el label
 * flotante se recorta con puntos suspensivos cuando no entra, y el caso donde
 * el nivel más importa es justo el del campo vacío (label sin encoger, el más
 * largo). Un badge recortado sería peor que no tenerlo.
 */
export function PassengerFieldLevelBadge({ level }: Props) {
  const { t } = useTranslation();
  const { labelKey, tone } = PASSENGER_FIELD_LEVEL_BADGE[level];

  return (
    <Box
      component="span"
      sx={{
        ...TONE_SX[tone],
        display: 'inline-block',
        mt: 0.5,
        px: 0.75,
        borderRadius: 0.75,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        lineHeight: 1.6,
      }}
    >
      {t(labelKey)}
    </Box>
  );
}
